/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Common_Full_GuideInputs */

const en_wc_common_full_guide = /** @type {(inputs: Wc_Common_Full_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full download guide`)
};

/**
* | output |
* | --- |
* | "Full download guide" |
*
* @param {Wc_Common_Full_GuideInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_common_full_guide = /** @type {((inputs?: Wc_Common_Full_GuideInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Common_Full_GuideInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_common_full_guide(inputs)
});
export { wc_common_full_guide as "wc.common.full_guide" }